import React from 'react';

import ReactDOM from 'react-dom';

import ActionButton from 'components/buttons/ActionButton';
import ActionLink from 'components/buttons/ActionLink';

export default function ProjectContentReviewFooter(props) {
  const openModal = (action) => {
    setAction(action);
    setModalIsOpen(true);
  };

  return (
    <>
      <PortaledActionButtons direction='left'>
        <ActionLink
          disableAfterClick={true}
          linkText='Previous'
          openUnsavedChangesModal={openModal}
          performCheck={props.anyUnsaved}
          styleClasses='tw-apply-outlined-button tw-apply-outlined-button--md tw-apply-outlined-button--blue-grey tw-apply-outlined-button--on-dark'
          url={`/projects/${props.projectId}/method${props.isReviewing ? '?review=true' : ''}`}
        />
      </PortaledActionButtons>
      <PortaledActionButtons direction='right'>
        <ActionButton
          buttonText='Finish'
          disabled={props.contentReviewSubmitting}
          onClick={props.submitProjectContentReview}
          styleClasses='tw-apply-filled-button tw-apply-filled-button--md tw-apply-filled-button--mint tw-apply-filled-button--on-dark'
        />
      </PortaledActionButtons>
    </>
  );
}

const PortaledActionButtons = (props) => {
  const buttonLocation = document.getElementsByClassName(
    `project-actions-${props.direction}`,
  );
  return ReactDOM.createPortal(props.children, buttonLocation[0]);
};
